import cn from 'classnames';
import { abbreviateNumber } from 'common/NumberUtils';
import { adjustedStarsToRating } from 'common/RatingUtilities';
import React from 'react';
import { StarV2, ThumbsUpV2 } from 'src/shared/design-system/Icon';
import { RatingIconContainer, StyledRatingChip } from './styles';

interface IProps {
  averageRating: number;
  className?: string;
  count?: number;
  showAsFiveStar?: boolean;
  showInline?: boolean;
}

export const RatingChip: React.FC<IProps> = ({
  averageRating,
  className,
  count = 0,
  showInline = false,
  showAsFiveStar = false,
}) => {
  const asFiveStar = adjustedStarsToRating(averageRating);
  const countValue = count ? ` (${abbreviateNumber(count)})` : ``;
  const value = showAsFiveStar ? asFiveStar : `${averageRating}%`;
  const text = `${value}${countValue}`;

  return (
    <StyledRatingChip
      className={cn(className, 'bg-butter-100')}
      text={text}
      showInline={showInline}
      showShadow={!showInline}
      icon={
        <RatingIconContainer>{showAsFiveStar ? <StarV2 height={9} width={9} /> : <ThumbsUpV2 />}</RatingIconContainer>
      }
    />
  );
};
